import { State, Action, StateContext, Selector } from '@ngxs/store';
import { DialogStateModel } from './dialog.state.model';
import { DialogActions } from './dialog.actions';
import { DialogService } from '../dialog.service';

@State<DialogStateModel>({
  name: 'dialog',
  defaults: {
    openDialog: null
  }
})
export class DialogState {
  /**
   * Selectors
   */
  @Selector()
  static getOpenDialog(state: DialogStateModel) {
    return state.openDialog;
  }

  /**
   * Actions
   */

  // Premium Content
  @Action(DialogActions.OpenPremiumContent)
  openPremiumContent(context: StateContext<DialogStateModel>, action: DialogActions.OpenPremiumContent) {
    const dialogRef = this.dialogService.openPremiumContentDialog();
    dialogRef.afterClosed()
      .subscribe(confirmed => {
        context.dispatch(new DialogActions.ClosePremiumContent(confirmed));
      });
  }

  @Action(DialogActions.ClosePremiumContent)
  closePremiumContent(context: StateContext<DialogStateModel>, action: DialogActions.ClosePremiumContent) {
    if (action.confirmed) {
      context.dispatch(new DialogActions.OpenUpgrade());
    }
  }

  // Upgrade
  @Action(DialogActions.OpenUpgrade)
  openUpgrade(context: StateContext<DialogStateModel>, action: DialogActions.OpenUpgrade) {
    this.dialogService.openUpgradeDialog();
  }


  constructor(
    private dialogService: DialogService
  ) {

  }
}
